<template>
  <b-modal
    :can-cancel="['escape', 'x', 'outside']"
    :active="active"
    @close="close"
    has-modal-card
    :width="1200"
  >
    <div class="modal-card" style="width: 1200px">
      <header class="modal-card-head">
        <p class="modal-card-title">
          {{ $t('compScenarioRulesSelectorModal.title') }}
        </p>
      </header>
      <section class="modal-card-body">
        <div class="columns">
          <div class="column is-one-quarter">
            <b-menu style="width: 15%; position: fixed">
              <b-menu-list>
                <b-menu-item
                  v-for="(module, indexm) in modules"
                  :key="indexm"
                  :expanded="
                    getModuleRules(module)
                      .map((obj) => obj.name)
                      .includes(selectedRule.name)
                  "
                  @click="activate(getModuleRules(module)[0])"
                >
                  <template slot="label" slot-scope="props">
                    <b-icon :icon="getIcon(module)" />
                    {{ $t(module) }}
                    <b-icon
                      class="is-pulled-right"
                      :icon="props.expanded ? 'caret-down' : 'caret-up'"
                    >
                    </b-icon>
                  </template>
                  <b-menu-item
                    v-for="(rule, indexr) in getModuleRules(module)"
                    :key="indexr"
                    @click="activate(rule)"
                    :active="selectedRule.name === rule.name"
                  >
                    <template slot="label">
                      <nav class="level">
                        <div class="level-left">
                          <div class="level-item">
                            {{ translate(rule, 'title') }}
                          </div>
                        </div>
                      </nav>
                    </template>
                  </b-menu-item>
                </b-menu-item>
              </b-menu-list>
            </b-menu>
          </div>
          <div class="column">
            <rule-card v-if="selectedRule" :rule="selectedRule" :ghgi="ghgi" />
          </div>
        </div>
      </section>
      <footer class="modal-card-foot buttons is-right">
        <nav class="level">
          <div class="level-left"></div>
          <div class="buttons level-right">
            <b-button class="button" @click="close" icon-left="close">
              {{ $t('cancel') }}
            </b-button>
            <b-button
              class="button"
              @click="addRule"
              :disabled="isDisabled(selectedRule)"
              type="is-primary"
              icon-left="plus"
            >
              {{ $t('add') }}
            </b-button>
          </div>
        </nav>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import Rule from '@/models/scenario/Rule.js'
import Scenario from '@/models/scenario/Scenario.js'
import Modules from '@/models/Modules.js'
import { useCoreStore } from '@/stores/core.js'

export default {
  name: 'RulesSelectorModal',
  components: {
    'rule-card': () => import('@/components/scenario/RuleCard.vue')
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    scenario: {
      type: Object,
      default: function () {
        return {}
      }
    },
    ghgi: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      selectedRule: Scenario.getRules(this.activeRules)[0]
    }
  },
  setup () {
    const coreStore = useCoreStore()
    return { coreStore }
  },
  computed: {
    activeRules: function () {
      return this.coreStore.conf.ACTIVE_RULES.value
    },
    modules: function () {
      return this.coreStore.activeModules(false).filter((module) => {
        return this.getModuleRules(module).length > 0
      })
    }
  },
  methods: {
    getIcon: function (module) {
      return Modules.getIcon(module)
    },
    activate: function (rule) {
      this.selectedRule = rule
    },
    getModuleRules: function (module) {
      return Scenario.getRules(this.activeRules).filter(
        (obj) => Modules.getParentModule(obj.module) === module
      )
    },
    translate (rule, key) {
      return Rule.translate(rule, key, this.$i18n.locale)
    },
    isDisabled (rule) {
      return !this.scenario.ruleCanBeAdded(rule, this.coreStore.options)
    },
    addRule () {
      this.$emit('add', this.selectedRule)
      this.initSelectedRule()
    },
    close () {
      this.$emit('close')
      this.initSelectedRule()
    },
    initSelectedRule () {
      this.selectedRule = this.getModuleRules(this.modules[0])[0]
    }
  },
  mounted () {
    this.initSelectedRule()
  }
}
</script>
